import ScrollMagic from 'scrollmagic';
require('scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap');

class IndustryBlock {
    constructor() {
        this.controller = new ScrollMagic.Controller();

        this.init();
    }

    init() {
        var $blocks = $('.js-industry-blocks');

        $blocks.each((index, element) => {
            new ScrollMagic.Scene({triggerElement: element, duration: 2000, offset: 0, triggerHook: 1})
                .setTween(new TimelineMax().add([this.getAnimation(element, index % 2)]))
                .addTo(this.controller);
        });
    }

    getAnimation(element, even) {
        let xPos = '10%';

        if (even) {
            xPos = '-10%';
        }

        let tween = new TweenMax.to($(element).find('.mask'), .5, {
            x: xPos,
            force3D: true,
            overwrite: 5
        });
        return tween;
    }
}

module.exports = IndustryBlock;